import { CopyOutlined } from "@ant-design/icons";
import { Button, Flex } from "antd";
import { MouseEvent } from "react";

import { PrimaryText } from "@/components/Typography/Styled";

export const QueueItemError = ({
    error,
    onCopy,
}: {
    error?: string;
    onCopy: (e: MouseEvent<HTMLElement>) => void;
}) => {
    if (!error) return null;

    return (
        <Flex gap={8} justify="space-between" align="center">
            <PrimaryText $textColor="error">{error}</PrimaryText>

            <Button
                type="text"
                icon={<CopyOutlined style={{ fontSize: 18 }} />}
                onClick={onCopy}
            />
        </Flex>
    );
};
